import { PlaceholderMap } from '@components/text-editor/plugin-placeholder';

import { useStore } from 'models/Provider';

export function usePlaceholderMap(type: string): PlaceholderMap {
  const { t } = useStore();

  switch (type) {
    case 'applicant_new_application':
      return {
        '{{ applicant_name }}': t('editor.placeholder.name'),
        '{{ applicant_first_name }}': t('editor.placeholder.first_name'),
        '{{ applicant_last_name }}': t('editor.placeholder.last_name'),
        '{{ job_name }}': t('editor.placeholder.job_title'),
      };
    case 'completion_email_admin':
      return {
        '{{ applicant_name }}': t('editor.placeholder.name'),
        '{{ applicant_first_name }}': t('editor.placeholder.first_name'),
        '{{ applicant_last_name }}': t('editor.placeholder.last_name'),
        '{{ job_title }}': t('editor.placeholder.job_title'),
        '{{ url }}': t('editor.placeholder.ob_url'),
        '{{ company_name }}': t('editor.placeholder.company_name'),
      };
    case 'completion_email_applicant':
      return {
        '{{ applicant_name }}': t('editor.placeholder.name'),
        '{{ applicant_first_name }}': t('editor.placeholder.first_name'),
        '{{ applicant_last_name }}': t('editor.placeholder.last_name'),
        '{{ job_title }}': t('editor.placeholder.job_title'),
        '{{ company_name }}': t('editor.placeholder.company_name'),
      };
    case 'rejection':
    case 'message':
    default:
      return {
        '{{ applicant_name }}': t('editor.placeholder.name'),
        '{{ job_name }}': t('editor.placeholder.job_title'),
        '{{ sender_name }}': t('editor.placeholder.sender_name'),
        '{{ applicant_first_name }}': t('editor.placeholder.first_name'),
        '{{ applicant_last_name }}': t('editor.placeholder.last_name'),
      };
  }
}
